import gql from 'graphql-tag';
import { ProductImageAllData } from '../fragments';

export default gql`
mutation adminSortProductImages (
    $product_id: ID!
    $image_ids: [ID!]!
) {
    adminSortProductImages (input: {
        product_id: $product_id
        image_ids: $image_ids
    }) {
        ...ProductImageAllData
    }
}
${ProductImageAllData}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/adminSortProductImages.ts